import React, { useState } from 'react';
import { MainLayout } from '../../../../components/MainLayout';
import { PagesHeader } from '../../../../components/shared/PagesHeader';
import { useTranslation } from 'react-i18next';
import { ROUTES } from './ReportFailure.config';
import { Formik } from 'formik';
import { reportFailureInitialValues } from '../../config/initialValues';
import { reportFailureValidationSchema } from '../../config/validation';
import { reportFailureFormConfig } from './formConfig';
import styles from './ReportFailure.styles.scss';
import ReportFailureDialog from '../../components/ReportFailureDialog/ReportFailureDialog';
import TechnicalFailureForm from '../../components/TechnicalFailureForm/TechnicalFailureForm';
import { reportTechnicalFailure } from '../../../../services/apis';

const ReportFailure = () => {
  const { t, i18n } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [failureValues, setFailureValues] = useState();

  const reportFailure = () => {
    return reportTechnicalFailure(failureValues);
  };

  return (
    <MainLayout className={styles.reportFailure} eInvoicing={true}>
      <PagesHeader withBreadcrumb={true} routes={ROUTES} />
      <div className={styles.container}>
        <h1>{t('failure_notification.report_technical_failure')}</h1>
        <Formik
          validateOnMount
          enableReinitialize
          validationSchema={reportFailureValidationSchema({
            t,
          })}
          initialValues={reportFailureInitialValues()}
          onSubmit={(values) => {
            setShowDialog(true);
            setFailureValues(values);
          }}
        >
          {({ values, errors, touched, setFieldValue, setTouched }) => {
            return (
              <TechnicalFailureForm
                values={values}
                errors={errors}
                touched={touched}
                submitLabel={t('common.next')}
                cancelLabel={t('common.cancel')}
                formConfig={reportFailureFormConfig({
                  t,
                  lang: i18n.language,
                  values,
                  setTouched,
                  setFieldValue,
                })}
              />
            );
          }}
        </Formik>
        <ReportFailureDialog
          isOpen={showDialog}
          setIsOpen={setShowDialog}
          onSubmit={reportFailure}
          failureType={failureValues?.faliureType}
        />
      </div>
    </MainLayout>
  );
};

export default ReportFailure;
